module.exports = __webpack_public_path__ + "img/banner-bg-md-2x.60bdf8b.jpg";